import './CaseStudyFilter.scss'

import React, { FunctionComponent } from 'react'
import Select, { components, IndicatorProps } from 'react-select'
import PuxIcon from 'Shared/components/PuxIcon/PuxIcon'
import { dt } from 'Shared/utils/dynamicRS'
import { t } from 'ttag'

import {
  FilterInputType,
  getDataByKey,
  getLocalizedSelectValue,
  SelectOptionType,
} from '../PuxRepeater'

const rootClass = `video-tutorial-filter`

const DropdownIndicator: FunctionComponent<
  IndicatorProps<SelectOptionType, false>
> = (props) => (
  <components.DropdownIndicator {...props}>
    <PuxIcon
      name={
        props.selectProps.menuIsOpen ? `arrows/up-arrow` : `arrows/down-arrow`
      }
      size={16}
      decorative
    />
  </components.DropdownIndicator>
)

const getSelectClassName = (value?: string) =>
  `react-select-container${value ? ` is-filled` : ``}`

const VideoTutorialFilter: FunctionComponent<FilterInputType> = (props) => {
  const data = props.completeData

  const rsSolution = dt(`Pux.RepeaterFilter.VideoTutorial.Solution`)
  const rsLevel = dt(`Pux.RepeaterFilter.VideoTutorial.Level`)
  const rsRole = dt(`Pux.RepeaterFilter.VideoTutorial.Role`)

  const cleanedSolutionData = getDataByKey(
    data,
    `videoTutorialSolution`,
    rsSolution
  )
  const cleanedLevelData = getDataByKey(data, `videoTutorialLevel`, rsLevel)
  const cleanedRoleData = getDataByKey(data, `videoTutorialRole`, rsRole)

  if (process.env.PROJECT === `EasyRedmineGatsby`) {
    props.setBindingTable({
      'filter-solution': {
        field: `videoTutorialSolution`,
      },
      'filter-difficulty': {
        field: `videoTutorialLevel`,
      },
    })
    return (
      <div className={`pux-repeater-filter ${rootClass}-wrapper`}>
        <div className={`pux-repeater-filter-item`}>
          <label htmlFor='filter-solution'>
            {t`Pux.RepeaterFilter.VideoTutorial.Solution.Label`}
          </label>
          <Select
            inputId='filter-solution'
            name='filter-solution'
            className={getSelectClassName(
              props.activeFilters[`videoTutorialSolution`]
            )}
            classNamePrefix='react-select'
            components={{ DropdownIndicator }}
            value={getLocalizedSelectValue(
              props.activeFilters[`videoTutorialSolution`],
              `Pux.RepeaterFilter.VideoTutorial.Solution`
            )}
            options={cleanedSolutionData}
            onChange={(selectedOption) =>
              props.updateUrl(
                selectedOption ? selectedOption.value : ``,
                `filter-solution`
              )
            }
          />
        </div>
        <div className={`pux-repeater-filter-item`}>
          <label htmlFor='filter-difficulty'>
            {t`Pux.RepeaterFilter.VideoTutorial.Level.Label`}
          </label>
          <Select
            inputId='filter-difficulty'
            name='filter-difficulty'
            className={getSelectClassName(
              props.activeFilters[`videoTutorialLevel`]
            )}
            classNamePrefix='react-select'
            components={{ DropdownIndicator }}
            value={getLocalizedSelectValue(
              props.activeFilters[`videoTutorialLevel`],
              `Pux.RepeaterFilter.VideoTutorial.Level`
            )}
            options={cleanedLevelData}
            onChange={(selectedOption) =>
              props.updateUrl(
                selectedOption ? selectedOption.value : ``,
                `filter-difficulty`
              )
            }
          />
        </div>
        <div
          className={`pux-repeater-filter-item pux-repeater-filter-item--clear`}
        >
          <button
            type='button'
            className='clear-button'
            onClick={props.clearFilter}
          >
            <span className='clear-button-text'>{t`Pux.RepeaterFilter.ClearAll`}</span>
            <PuxIcon name='arrows/refresh' size={24} decorative />
          </button>
        </div>
      </div>
    )
  } else if (process.env.PROJECT === `EasyProjectGatsby`) {
    props.setBindingTable({
      'filter-role': {
        field: `videoTutorialRole`,
      },
    })
    return (
      <div className={`pux-repeater-filter ${rootClass}-wrapper`}>
        <div className={`pux-repeater-filter-item`}>
          <label htmlFor='filter-role'>
            {t`Pux.RepeaterFilter.VideoTutorial.Role.Label`}
          </label>
          <Select
            inputId='filter-role'
            name='filter-role'
            className={getSelectClassName(
              props.activeFilters[`videoTutorialRole`]
            )}
            classNamePrefix='react-select'
            components={{ DropdownIndicator }}
            value={getLocalizedSelectValue(
              props.activeFilters[`videoTutorialRole`],
              `Pux.RepeaterFilter.VideoTutorial.Role`
            )}
            options={cleanedRoleData}
            onChange={(selectedOption) =>
              props.updateUrl(
                selectedOption ? selectedOption.value : ``,
                `filter-role`
              )
            }
          />
        </div>
        <div
          className={`pux-repeater-filter-item pux-repeater-filter-item--clear`}
        >
          <button
            type='button'
            className='clear-button'
            onClick={props.clearFilter}
          >
            <span className='clear-button-text'>{t`Pux.RepeaterFilter.ClearAll`}</span>
            <PuxIcon name='arrows/refresh' size={24} decorative />
          </button>
        </div>
      </div>
    )
  } else {
    return null
  }
}

export default VideoTutorialFilter
